import api from './api';

export const registrationQuestionService = {
  async getQuestions(activeOnly = true) {
    const response = await api.get('/registration-questions', {
      params: { activeOnly }
    });
    return response.data.data;
  }
};
